export default {
  created () {
    this.$bus.$on(`Call-ListForm-ValidateItem-${this.listFormItemID}`, this.mixEventValidate)
    this.$bus.$on(`Call-ListForm-Validate-${this.listFormID}`, this.mixEventValidate)
  },
  beforeDestroy () {
    this.$bus.$off(`Call-ListForm-ValidateItem-${this.listFormItemID}`, this.mixEventValidate)
    this.$bus.$off(`Call-ListForm-Validate-${this.listFormID}`, this.mixEventValidate)
  },
  props: {
    config: {
      type: Object,
      default: () => ({
        id: null,
        mainField: 'id'
      })
    },
    data: { type: Object, required: true }
  },
  computed: {
    listFormID () {
      return this.config.id
    },
    listFormItemID () {
      let mainField = this.config.mainField || 'id'
      return `${this.listFormID}-${this.data[mainField]}`
    }
  },
  methods: {
    // REQUIRED INTERFACE
    getData () {
      throw new Error(`List Form => Get Data -> REQUIRED INTERFACE`)
    },
    validate () {
      return Promise.reject(new Error(`List Form => Validate -> REQUIRED INTERFACE`))
    },
    // END REQUIRED INTERFACE
    mixEventValidate (cb) {
      this.validate()
        .then(() => {
          cb(this.getData())
        })
        .catch((err) => {
          cb(err)
        })
    }
  }
}
